import React, { useRef } from 'react'
import styles from './FV.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const FV: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.FV} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h1 className={styles.FVTitle}>
          ただ作るだけでは終わらせない。
          <br />
          ビジネスの成果を導くスマホアプリ開発。
        </h1>
        <p className={styles.FVText}>
          i3DESIGNは、企業の成長を支える“ユーザー体験起点のアプリ開発”を提供します。
          <br />
          構想からデザイン、開発、運用までをワンチームで伴走し、金融・IT/情報通信・小売/流通・人材など、さまざまな業界で培ったUXとテクノロジーの力で、ビジネスの変革を加速させます。
        </p>
        <ul className={styles.FVLink}>
          <li className={styles.FVLink__itemRed}>
            <a href="#contact">お問い合わせはこちら</a>
          </li>
          <li className={styles.FVLink__itemWhite}>
            <a href="/download/application-development/">資料ダウンロードはこちら</a>
          </li>
        </ul>
      </div>
    </section>
  )
}
export default FV
